<template>
  <div>
    <Batch title="项目奖申报批次" @handleNext="handleNext" />
  </div>
</template>

<script>
import Batch from '@/components/batch/Batch'
export default {
  components: { Batch },
  data () {
    return {}
  },
  created () {},
  methods: {
    handleNext(e) {
      this.$router.push({ path: '/project', query: { batchId: e.id } })
    }
  }
}
</script>
